export const PATIENT_RELATIONS = [
  'self',
  'spouse',
  'child',
  'father',
  'mother',
  'sibling',
  'other',
] as const

export type PatientRelation = (typeof PATIENT_RELATIONS)[number]

export const PATIENT_RELATION_LABELS: Record<PatientRelation, string> = {
  self: 'خودم',
  spouse: 'همسر',
  child: 'فرزند',
  father: 'پدر',
  mother: 'مادر',
  sibling: 'خواهر / برادر',
  other: 'سایر',
}

export function isPatientRelation(value: unknown): value is PatientRelation {
  return typeof value === 'string' && (PATIENT_RELATIONS as readonly string[]).includes(value)
}

export function patientRelationLabel(relation: string): string {
  if (isPatientRelation(relation)) return PATIENT_RELATION_LABELS[relation]
  return PATIENT_RELATION_LABELS.other
}
